import MiPagination from './MiPagination.vue'

export default MiPagination
